(function () {
    'use strict';

    angular.module("imApp").factory("consignmentLineAssignService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3565,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 3567,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
